import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
	selector: 'cp-double-line-dropdown-item',
	templateUrl: './double.line.dropdown.item.component.html',
	styleUrls: ['./double.line.dropdown.item.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})

export class DoubleLineDropdownItem {
	@Input() primaryLabel: string = '';
	@Input() secondaryLabel: string | null = null;
	@Input() description: string[] = null;

	/** When true, the row renders as a single, compact line (20px) even if description exists */
	@Input() forceSingleLine = false;
	@Input() maxTooltipWidth: number = null;
}
